import ProductShow from './ProductShow'
export {ProductShow}
export default ProductShow
